import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function ProfitPercentage ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const profitPercentage = [
    ['Mês', 'Margem de lucro bruto (%)', 'Margem de lucro líquido (%)'],
    ...Object.entries (data).map (([month, values]) => [
      month,
      Number (values.rawProfitPercentage) || 0,
      Number (values.netProfitPercentage) || 0,
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Margem de lucro (%)</SubTitle>
      <ColumnChart
        data={profitPercentage}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          legend: 'none',
          colors: ['#44CF6C', '#35A7FF'],
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Valor (R$)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
